import { BasicLayout, OrientationMap, Orientor } from '@1x2network/layout'
import { ContainerSpecification, ScalingText, ScalingTextSpecification } from '@1x2network/pixi_assets'
import { Page, SplashComponent } from '@1x2network/pixi_splash'
import { HoldAndWinLoop, HoldAndWinLoopSpecification } from '../splash/loops/HoldAndWinLoop'
import { HoldAndWinCollectorLoop } from '../splash/loops/HoldAndWinCollectorLoop'

export class TransitionPage extends Page<TransitionPageSpec> {
    private layout: BasicLayout
    private hawText: Orientor<ScalingText>

    constructor(options: { spec: TransitionPageSpec; layout: BasicLayout }) {
        super({ spec: options.spec })

        const spec = this.specification.sections
        this.layout = options.layout
        this.hawText = new Orientor({
            layout: this.layout,
            spec: spec.haw.text,
            create: (spec: ScalingTextSpecification) => new ScalingText({ spec, parent: this }),
            onOrient: (active, inactive) => {
                active.visible = true
                inactive.visible = false
            },
        })

        const components: SplashComponent[] = [
            new HoldAndWinCollectorLoop({ parent: this, layout: this.layout, spec: spec.haw.loop }),
        ]

        this.addComponents(...components)
    }
}

export interface TransitionPageSpec extends ContainerSpecification {
    sections: {
        haw: {
            loop: HoldAndWinLoopSpecification
            text: OrientationMap<ScalingTextSpecification>
        }
    }
}
